// import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { NotificationProvider } from "./context/NotificationContext";
import Login from "./components/Login/Login.jsx";
import ResetPasswordPage from "./components/Login/ResetPasswordPage.jsx";
import SalesExecutive from "./pages/SalesExecutive";
import AdminDashboard from "./pages/AdminDashboard.jsx";
import SaleDetails from "./pages/SaleDetails";
import DisplayProofDetails from "./pages/DisplayProofDetails";
import VisitDetails from "./pages/VisitDetails";
import {
  ProtectedRoute,
  PublicOnlyRoute,
} from "./components/Auth/RouteGuards.jsx";
import { FIELD_ROLES, ROLES } from "./constants/roles";
// import RecordSale from "./pages/RecordSale";

import "./styles/App.css";

const App = () => {
  return (
    <NotificationProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <PublicOnlyRoute>
                <Login />
              </PublicOnlyRoute>
            }
          />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/promoter"
            element={
              <ProtectedRoute allowedRoles={FIELD_ROLES}>
                <SalesExecutive />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sale-details"
            element={
              <ProtectedRoute allowedRoles={FIELD_ROLES}>
                <SaleDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/display-proof-details"
            element={
              <ProtectedRoute allowedRoles={FIELD_ROLES}>
                <DisplayProofDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/visit-details/:sessionGroupId"
            element={
              <ProtectedRoute allowedRoles={FIELD_ROLES}>
                <VisitDetails />
              </ProtectedRoute>
            }
          />
          {/* <Route path="/record-sale" element={<RecordSale />} /> */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER_ADMIN]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </NotificationProvider>
  );
};

export default App;
